import React, { Component } from 'react';

import DockPanel from './DockPanel/DockPanel';

/**
 * The project wizard, shown inside the app instead of a separate tab.
 *
 * project-wizard.html is a self-contained page and is embedded rather than
 * reimplemented — it keeps its own drafts in localStorage, which is shared with
 * this origin, so work survives closing the panel and reopening it.
 *
 * It sits in a dock panel rather than a dialog. The wizard's whole job is
 * producing art that the grid behind it renders, and a dialog that has to be
 * dismissed to see its own result makes the artist work in round trips: edit,
 * close, look, reopen. Floating it means the panel can be moved aside or rolled
 * up to its title bar with the work still in progress.
 *
 * The frame is only mounted while the panel is open. The wizard runs live art
 * previews of its own, and leaving those rendering behind a closed panel would
 * burn cycles for nothing.
 */
class WizardModal extends Component {
  render() {
    const { show, onHide } = this.props;
    return (
      <DockPanel
        show={show}
        onClose={onHide}
        title="project wizard"
        storageKey="wizard"
        defaultWidth={980}
        defaultHeight={640}
        minWidth={420}
        minHeight={280}
      >
        {show && (
          <iframe
            title="project wizard"
            // The single-file build inlines the page as window.__WIZARD_DOC.
            // A copy opened from disk has no server behind it, so a relative
            // src gave the artist a file-not-found page where the wizard
            // should have been.
            {...(typeof window !== 'undefined' && window.__WIZARD_DOC
              ? { srcDoc: window.__WIZARD_DOC }
              : { src: `${process.env.PUBLIC_URL}/project-wizard.html` })}
            style={{ width: '100%', height: '100%', border: 0, display: 'block' }}
          />
        )}
      </DockPanel>
    );
  }
}

export default WizardModal;
